import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const AppStudioPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8 bg-gray-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <h1 className="text-5xl lg:text-6xl font-light leading-tight mb-6">
              App Studio
            </h1>
            <a
              href="https://diffusion.sh"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-800 transition-colors inline-block text-lg"
            >
              Launch App Studio →
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AppStudioPage;
